/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { MapCheapestRate } from './MapCheapestRate';
export type MapAccommodation = {
    type: string;
    id: string;
    cheapestRate: MapCheapestRate | null;
    reservationType: MapAccommodation.reservationType;
};
export namespace MapAccommodation {
    export enum reservationType {
        REAL_TIME = 'RealTime',
        QUERY = 'Query',
    }
}
